module.exports={turnstile_modal:{message:"보안 절차 진행 중"}};